import React from 'react';
import { DateRangePicker, DateRangePickerProps } from '@heroui/react';
import cn from 'classnames';
import styles from './CustomDateRangePicker.module.scss';

interface CustomDateRangePickerProps extends Omit<DateRangePickerProps, 'classNames'> {
  errorMessage?: string;
  showError?: boolean;
}

export const CustomDateRangePicker = (props: CustomDateRangePickerProps) => {
  const { errorMessage, showError = false, ...dateRangePickerProps } = props;

  const isInvalid = !!errorMessage;
  const classnamesDatepicker = {
    base: styles.datepickerBase,
    label: cn(styles.datepickerInputLabel, isInvalid ? styles.error : ''),
    inputWrapper: cn(styles.datepickerInputWrapper, isInvalid ? styles.error : ''),
    innerWrapper: styles.innerWrapper,
    input: cn(styles.datepickerText, styles.valueText),
    segment: styles.segment,
    separator: styles.separator,
    calendar: styles.datepickerCalendar,
    calendarContent: styles.datepickerCalendarContent,
    helperWrapper: styles.errorMessage,
  };

  return (
    <DateRangePicker
      {...dateRangePickerProps}
      popoverProps={{ shouldBlockScroll: false }}
      isInvalid={isInvalid}
      errorMessage={showError ? errorMessage : undefined}
      classNames={classnamesDatepicker}
    />
  );
};
